import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue')
    },
    {
        path: "/dashboard_1",
        name: "Dashboard 1",
        component: () => import("@/views/Dashboard2.vue")
    },
    {
        path: '/Report',
        name: 'Report',
        component: () => import('@/views/Report.vue')
    },
    {
        path: '/Report/Funcionarios',
        name: 'ReportFunc',
        component: () => import('@/views/ReportFunc.vue')
    },
    {
        path: '/Create/:nameType',
        name: 'Create',
        component: () => import('@/views/Create.vue')
    },
    {
        path: '/CRUD/:nameType',
        name: 'CRUD',
        component: () => import('@/views/CRUD.vue')
    },
    {
        path: '/View/:nameType/:id',
        name: 'View',
        component: () => import('@/views/View.vue')
    },
    {
        path: '/Edit/:nameType/:id',
        name: 'Edit',
        component: () => import('@/views/Edit.vue')
    },
    {
        path: '/Map',
        name: 'Map',
        component: () => import('@/views/Map.vue')
    },
    {
        path: '/Management',
        name: 'Management',
        component: () => import('@/views/Management.vue')
    },
    {
        path: '/Management/:id',
        name: 'ManagementItem',
        component: () => import('@/views/ManagementItem.vue')
    },
    {
        path: '/ManagementNew',
        name: 'ManagementNew',
        component: () => import('@/views/ManagementItemN.vue')
    },
    {
        path: '/import/:type',
        name: 'Import',
        component: () => import('@/views/Import.vue')
    },
]

const router = new VueRouter({
    routes
})

export default router
